import { Component, Input, OnInit, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ToggleComponent } from '@rensa/shared/classes/toggle-component';

@Component({
    selector: 'app-switch',
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.css'],
})
export class SwitchComponent extends ToggleComponent implements OnInit {
    @Input() inline!: boolean;
    @Input() type!: 'danger' | null;
    classes: string[] = [];

    constructor(@Self() @Optional() control: NgControl) {
        super(control);
    }

    ngOnInit(): void {
        if (this.inline) {
            this.classes.push('inline');
        }

        if (this.type) {
            this.classes.push(this.type);
        }
    }
}
